
const sectionsAsList = document.getElementsByClassName('shopify-section');
let sections = Array.prototype.slice.call(sectionsAsList);

sections = sections.filter((section) => section.id !== 'shopify-section-announcement-bar');
sections = sections.filter((section) => section.id !== 'shopify-section-header');

sections.forEach(section => {
  section.classList.add('scrollable', 'visible');
});


window.onscroll = () => {
  if (window.innerHeight + 260 < document.body.clientHeight) {
    for (let i = 0; i < sections.length; i++) {
      const bound = sections[i].getBoundingClientRect();
      const visibleOnBottom = (bound.top - document.documentElement.clientHeight) <= -260;
      const visibleOnTop = (bound.bottom - document.getElementById('shopify-section-header').clientHeight) > 260;
      (visibleOnBottom && visibleOnTop) ? sections[i].classList.add('visible') : sections[i].classList.remove('visible');
      if (i === sections.length - 1) {
        (sections[i].clientHeight + bound.top <= document.documentElement.clientHeight + 100) ? sections[i].classList.add('visible') : sections[i].classList.remove('visible');
      }
    } 
  }
}
